import { apiClient } from '../api/client';

export type GiftType = 'PRODUCT' | 'CREDIT';

export interface Gift {
  id: string;
  code: string;
  name: string;
  type: GiftType;
  productId?: string;
  creditAmount?: number;
  usageLimit?: number;
  usageCount: number;
  expiresAt?: string;
  isActive: boolean;
  isExpired?: boolean;
  hasReachedLimit?: boolean;
  canBeRedeemed?: boolean;
  createdAt: string;
}

export interface GiftRedemption {
  id: string;
  giftId: string;
  playerId: string;
  redeemedAt: string;
  gift: {
    code: string;
    name: string;
    type: GiftType;
    creditAmount?: number;
    productId?: string;
  } | null;
}

export interface RedeemGiftRequest {
  code: string;
}

export interface RedeemGiftResponse {
  message: string;
  gift: {
    id: string;
    code: string;
    name: string;
    type: GiftType;
    productId?: string;
    creditAmount?: number;
  };
}

export const giftService = {
  /**
   * Lista todos os resgates de presentes do jogador
   */
  async getPlayerRedemptions(
    storeId: string,
    playerId: string
  ): Promise<GiftRedemption[]> {
    const response = await apiClient.get<{ redemptions: GiftRedemption[] }>(
      `/public/stores/${storeId}/gifts/redemptions`
    );
    return response.redemptions || [];
  },

  /**
   * Resgata um presente usando um código
   */
  async redeemGift(
    storeId: string,
    playerId: string,
    data: RedeemGiftRequest
  ): Promise<RedeemGiftResponse> {
    const response = await apiClient.post<RedeemGiftResponse>(
      `/public/stores/${storeId}/gifts/redeem`,
      data
    );
    return response;
  },
};
